var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 12C21.5625 17.796 17.0595 22.5 11.5 22.5C5.94047 22.5 1.4375 17.796 1.4375 12C1.4375 6.19875 5.94047 1.5 11.5 1.5C17.0595 1.5 21.5625 6.19875 21.5625 12Z",
    fill: "#283544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2165 9.34304C16.1616 9.37646 14.8545 10.0819 14.8545 11.6459C14.9161 13.4296 16.504 14.0551 16.5312 14.0551C16.504 14.0885 16.2915 14.9072 15.6621 15.7654C15.1625 16.5047 14.608 17.25 13.7661 17.25C12.9652 17.25 12.6777 16.7573 11.7536 16.7573C10.7611 16.7573 10.4803 17.25 9.72052 17.25C8.87855 17.25 8.28301 16.4647 7.75623 15.7324C7.07185 14.7739 6.49015 13.2698 6.46962 11.8256C6.45578 11.0603 6.60667 10.308 6.98971 9.66904C7.53033 8.77699 8.49551 8.17143 9.54954 8.15146C10.3571 8.12498 11.0759 8.6906 11.5687 8.6906C12.0411 8.6906 12.9241 8.15146 13.9232 8.15146C14.3545 8.1519 15.5045 8.27822 16.2165 9.34304ZM11.5004 7.99866C11.3567 7.29978 11.7536 6.60089 12.1232 6.15508C12.5955 5.61594 13.3415 5.25 13.9848 5.25C14.0259 5.94889 13.7656 6.63432 13.3004 7.13352C12.883 7.67266 12.1643 8.07853 11.5004 7.99866Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentApple);
export default __webpack_public_path__ + "static/media/payment-apple.472f92b73e753b49ca4743f3609540a7.svg";
export { ForwardRef as ReactComponent };